//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Field, Button, Toast } from "vant";
import Api from "../../../fetch/api";

export default {
  name: "BlueSkySt",
  components: {
    [Field.name]: Field,
    [Button.name]: Button,
    [Toast.name]: Toast
  },
  data() {
    return {
      mobile: ''
    };
  },
  methods: {
    bindBobile() {
      if (!this.mobile || this.mobile.length === 0) {
        Toast({
          message: "请输入手机号",
          icon: "edit"
        });
        return;
      }
      if (this.mobile.length !== 11) {
        Toast({
          message: "手机号错误",
          icon: "phone-o"
        });
        return;
      }
      Toast.loading({
        message: "领取中...",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0
      });
      const adData = {
        type: "LANTIAN_JIAXIAO",
        name: "南职蓝天驾校用户信息",
        reservedOne: this.mobile
      };
      Api.setAdRecord(adData)
        .then(() => {
          Toast.clear();
          Toast({
            message: "领取成功",
            icon: "medal-o"
          });
        })
        .catch((e) => {
          Toast.clear();
          Toast({
            message: "领取失败",
            icon: "smile-o"
          });
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/page/collectCustomerInfo/studentDriver/blueSkySt.vue